import { observer } from 'mobx-react';
import React from 'react';
import classnames from 'classnames';

import { UiControlPropsType } from 'shared/types';

import { UiIcon } from '../UiIcon';

import './styles.scss';

type PropsType = UiControlPropsType<string | null> & {
    template?: 'large' | 'normal' | 'small',
    placeholder?: string,
    isClearable?: boolean
    isReadOnly?: boolean
    icon?: React.ReactNode,
};

export const UiInput = observer(function UiInput({
    value,
    name = 'ui-input',
    className,
    onChange = () => undefined,
    template = 'normal',
    placeholder,
    isClearable,
    isReadOnly,
    icon,
}: PropsType) {
    const classNames = classnames('ui-new-input', `ui-new-input--${template}`, className, {
        'ui-new-input--clearable': isClearable && !isReadOnly,
        'ui-new-input--icon': !!icon,
        'ui-new-input--readonly': isReadOnly,
    });

    return (
        <div className={classNames}>
            <input
                type="text"
                placeholder={placeholder}
                className={'ui-new-input__control ui-new-input__control--validation'}
                value={value || ''}
                name={name}
                readOnly={isReadOnly}
                onChange={e => {
                    onChange({
                        name,
                        value: e.target.value,
                    });
                }}
            />
            {!!icon && <div className="ui-new-input__icon">{icon}</div>}
            {(isClearable && !isReadOnly && !!value) && (
                <div className="ui-new-input__clear" onClick={() => onChange({ name, value: '' })}>
                    <UiIcon.X size={16} />
                </div>
            )}
        </div>
    );
});
